import React, { useEffect, useState } from "react";
import { db } from "../../firebase/firebase";
import { collection, getDocs } from "firebase/firestore";

export default function MigrationHistory() {
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const load = async () => {
      const snap = await getDocs(collection(db, "migrations"));
      const list = snap.docs.map(d => d.data());
      setHistory(list.sort((a, b) => a.version - b.version));
    };

    load();
  }, []);

  return (
    <div className="migration-history">
      <h2>Migration History</h2>

      {history.length === 0 && <p>No migrations applied yet.</p>}

      <ul>
        {history.map(m => (
          <li key={m.version}>
            <strong>v{m.version}</strong> — {m.name}
            <br />
            <small>{m.appliedAt.toDate().toLocaleString()}</small>
          </li>
        ))}
      </ul>
    </div>
  );
}
